













































import { defineComponent } from '@nuxtjs/composition-api'
import { ciMakeOffer } from '~/icons/source/regular/make-offer'
import CShimmer from '~/components/shared/configurable/shimmer/CShimmer.vue'
import CNewBadge from '~/components/shared/configurable/badge/CNewBadge.vue'

export default defineComponent({
  components: { CNewBadge, CShimmer },
  props: {
    title: { type: String, default: null },
    subtitle: { type: String, default: null },
    icon: { type: Object, default: () => {} },
    iconClass: { type: [String, Object, Array], default: 'tw-text-blue-700' },
    link: { type: String, default: null },
    href: { type: String, default: null },
    loading: { type: Boolean, default: false },
    isNew: { type: Boolean, default: false },
    containerClasses: { type: [String, Array], required: false, default: '' }
  },
  setup() {
    return {
      makeOfferIcon: ciMakeOffer
    }
  }
})
